'use client'

import { Box } from '@mui/material'
import dynamic from 'next/dynamic'

// Sử dụng dynamic import với ssr: false cho các component nặng bên dưới trang chủ để giảm bundle size ban đầu và cải thiện Lighthouse Performance
export const SectionVideo = dynamic(() => import('./section-video'), {
  ssr: false,
  loading: () => <Box sx={{ minHeight: { xs: 300, md: 500 } }} />,
})

export const SectionShop = dynamic(() => import('./section-shop'), {
  ssr: false,
  loading: () => <Box sx={{ minHeight: { xs: 400, md: 600 } }} />,
})

export const SectionTrendProducts = dynamic(() => import('./section-trend-product'), {
  ssr: false,
  loading: () => <Box sx={{ minHeight: { xs: 300, md: 500 } }} />,
})

export const SectionFeedBack = dynamic(() => import('./section-feedback'), {
  ssr: false,
  loading: () => <Box sx={{ minHeight: { xs: 200, md: 400 } }} />,
})

export const SectionImageSlide = dynamic(() => import('./section-image-slide'), {
  ssr: false,
  loading: () => <Box sx={{ minHeight: { xs: 100, md: 150 } }} />,
})
